import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LaunchDarklyService } from '../../../../../core/services/launchdarkly.service';
import { LayoutService } from '../../../layout.service';
import { Sidebar2ToggleService } from '../../../sidebar.2/sidebar2-toggle.service';
import { MenuName } from './menubar-menu-type.model';

@Injectable({
    providedIn: 'root',
})
export class MenubarScrollService {
    #sidebar2ToggleService = inject(Sidebar2ToggleService);
    #layoutService = inject(LayoutService);
    #lds = inject(LaunchDarklyService);

    #mobileLeft = 0;
    #activeTabsRight = 0;

    MENUBAR_LEFT = 200;
    MENUBAR_GUTTER = 50;
    ANIMATION_DURATION = 500;
    #animationInterval?: number;

    #atRightEndSource = new BehaviorSubject<boolean>(false);
    atRightEnd$ = this.#atRightEndSource.asObservable();
    set atRightEnd(val: boolean) {
        this.#atRightEndSource.next(val);
    }

    #atLeftEndSource = new BehaviorSubject<boolean>(true);
    atLeftEnd$ = this.#atLeftEndSource.asObservable();
    set atLeftEnd(val: boolean) {
        this.#atLeftEndSource.next(val);
    }

    doRight(duration = this.ANIMATION_DURATION) {
        this.#setLeft();
        const targetElement = $('#menubar-job')[0];
        if (targetElement) {
            this.atRightEnd = true;
            this.atLeftEnd = false;
            this.#scrollMenu(duration, targetElement);
        }
    }

    doLeft() {
        this.#setLeft();
        const targetElement = $('#menubar-estimate')[0];
        if (targetElement) {
            this.atRightEnd = false;
            this.atLeftEnd = true;
            this.#scrollMenu(this.ANIMATION_DURATION, targetElement);
        }
    }

    #scrollMenu(duration: number, targetElement: HTMLElement) {
        const leftInner = Math.min(this.MENUBAR_LEFT, this.MENUBAR_LEFT - targetElement.offsetLeft);
        const newPos = leftInner + this.MENUBAR_GUTTER;

        $('.topbar-menu').animate({ left: newPos }, duration, 'linear');
    }

    #setLeft() {
        const isMobile = this.#layoutService.isMobile();
        if (!isMobile && !this.#sidebar2ToggleService.open) this.MENUBAR_LEFT = 45;
        else if (isMobile) this.MENUBAR_LEFT = 0;
        else this.MENUBAR_LEFT = 200;
    }

    doLeftMobile(duration = this.ANIMATION_DURATION) {
        this.atRightEnd = false;
        this.#mobileLeft = this.#mobileLeft - window.innerWidth + this.MENUBAR_GUTTER;
        if (this.#mobileLeft >= 0) {
            $('.topbar-menu').animate({ left: this.#mobileLeft * -1 }, duration, 'linear');
            if (this.#mobileLeft === 0) this.atLeftEnd = true;
        } else {
            this.#mobileLeft = 0;
            this.atLeftEnd = true;
            $('.topbar-menu').animate({ left: this.#mobileLeft }, duration, 'linear');
        }
    }

    doRightMobile(menuName: string) {
        this.atLeftEnd = false;

        if (!this.#activeTabsRight && menuName !== MenuName.Job) {
            const targetElement = $(`#menubar-${menuName}`)[0];
            if (targetElement) {
                this.#activeTabsRight = targetElement.offsetWidth + this.MENUBAR_GUTTER;
                // check for jobs
                const jobs = $('#menubar-job')[0];
                if (jobs) {
                    this.#activeTabsRight = jobs.offsetWidth + this.#activeTabsRight + this.MENUBAR_GUTTER;
                }
            }
        }

        this.#mobileLeft = window.innerWidth + this.#mobileLeft - this.MENUBAR_GUTTER;
        if (this.#activeTabsRight > this.#mobileLeft) {
            $('.topbar-menu').animate({ left: (this.#mobileLeft - this.MENUBAR_GUTTER * 2) * -1 }, this.ANIMATION_DURATION, 'linear');
            if (this.#activeTabsRight - this.#mobileLeft < 50) this.atRightEnd = true;
        } else {
            this.atRightEnd = true;
            this.#mobileLeft = this.#mobileLeft + this.MENUBAR_GUTTER - window.innerWidth;
        }
    }

    setJobsMenu() {
        const targetElement = $('#menubar-job')[0];
        if (targetElement) {
            const leftInner = targetElement?.offsetLeft;

            const width = targetElement?.offsetWidth;
            this.#mobileLeft = leftInner - 50;
            this.atRightEnd = false;

            $('.topbar-menu').animate({ left: this.#mobileLeft * -1 }, 1, 'linear');

            //check for estimates menu
            const estimates = $('#menubar-estimate')[0];
            if (estimates) {
                this.#activeTabsRight = estimates.offsetWidth + width + this.MENUBAR_GUTTER + this.MENUBAR_GUTTER;
            } else {
                this.atLeftEnd = true;
                this.#activeTabsRight = width + this.MENUBAR_GUTTER + this.MENUBAR_GUTTER;
            }
        }
    }

    reset() {
        this.#activeTabsRight = 0;
        this.#mobileLeft = 0;
    }

    moveRight(menu: string) {
        const targetElement = document.getElementById(`menubar-${menu}`);
        if (!targetElement) return;
        this.atLeftEnd = false;
        const newQuoteButtonOffset = this.#lds.get('estimate-uplift-quote-button') ? 200 : 0;
        this.#animationInterval = window.setInterval(() => {
            const activeTabsRight =
                (targetElement.offsetParent as HTMLElement).offsetLeft +
                targetElement.offsetLeft +
                targetElement.offsetWidth +
                newQuoteButtonOffset;
            if (activeTabsRight > window.innerWidth - 100) {
                const left = $('.topbar-menu').css('left');
                const numLeft = Number(left.split('px')[0]);
                $('.topbar-menu').css('left', numLeft - 1);
            }
        }, 6);
    }

    moveLeft(menu: string) {
        this.#setLeft();
        const targetElement = document.getElementById(`menubar-${menu}`);
        if (!targetElement) return;
        this.#animationInterval = window.setInterval(() => {
            const activeTabsLeft = (targetElement.offsetParent as HTMLElement).offsetLeft + targetElement.offsetLeft;
            if (activeTabsLeft < this.MENUBAR_LEFT + this.MENUBAR_GUTTER) {
                const left = $('.topbar-menu').css('left');
                const numLeft = Number(left.split('px')[0]);
                $('.topbar-menu').css('left', numLeft + 1);
            }
        }, 6);
    }

    clearMove() {
        if (this.#animationInterval) window.clearInterval(this.#animationInterval);
    }

    resetLeft(menuName: string) {
        this.#setLeft();
        const targetElement = $(`#menubar-${menuName}`)[0];
        if (targetElement) {
            this.atRightEnd = false;
            this.atLeftEnd = true;
            this.#scrollMenu(1, targetElement);
        }
    }
}
